module.exports = __webpack_public_path__ + "img/credit_construction.eb43ca52.png";